import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { DrawerV2 } from 'site-modules/shared/components/drawer/drawer-v2';
import { ErrorBoundary } from 'site-modules/shared/components/error-boundary/error-boundary';

import { FindStyleDrawerBackButton } from './find-style-drawer-back-button';
import { FindStyleDrawerContentAsync } from './find-style-drawer-content-async';

import './find-style-drawer.scss';

export class FindStyleDrawer extends Component {
  static propTypes = {
    creativeId: PropTypes.string.isRequired,
    className: PropTypes.string,
    isMobile: PropTypes.bool,
    drawerToggleLinkText: PropTypes.string,
    drawerContentHeaderText: PropTypes.string,
    drawerContentSubHeaderText: PropTypes.string,
    drawerContentCtaText: PropTypes.string,
    drawerClassNames: PropTypes.string,
    drawerContainerClassNames: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    isMobile: false,
    drawerToggleLinkText: "Don't know your style?",
    drawerContentHeaderText: "Don't know which style to pick? No problem!",
    drawerContentSubHeaderText: 'We can help shorten the list of styles for you, just provide us with your',
    drawerContentCtaText: 'Look up my style',
    drawerClassNames: '',
    drawerContainerClassNames: '',
  };

  state = {
    isOpen: false,
    innerModalOpened: false,
    wasDrawerOpenedBefore: false, // flag if the drawer been ever opened so the content would not unmount after closing (purpose is to preserve openDrawer/closeDrawer callbacks)
  };

  trackDrawerToggle = () => {
    const { creativeId, drawerToggleLinkText } = this.props;
    const { isOpen } = this.state;
    const openSubactionName = TrackingConstant.FIND_STYLE;

    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
      event_data: {
        action_name: TrackingConstant.ACTION_SHOW_CONTENT,
        action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
        action_cause: TrackingConstant.ACTION_CAUSE_LINK_CLICK,
        subaction_name: isOpen ? openSubactionName : TrackingConstant.CLOSE_POPUP,
        creative_id: creativeId,
        value: isOpen ? drawerToggleLinkText.replace(/\?/g, '') : 'close',
      },
    });
  };

  toggleDrawer = () =>
    this.setState(prevState => ({ isOpen: !prevState.isOpen, wasDrawerOpenedBefore: true }), this.trackDrawerToggle);

  handleInnerModalOpen = () => {
    this.setState({ innerModalOpened: true });
  };

  handleInnerModalClose = () => {
    this.setState({ innerModalOpened: false });
  };

  render() {
    const { className, drawerToggleLinkText, creativeId, drawerClassNames, drawerContainerClassNames } = this.props;
    const { isOpen, wasDrawerOpenedBefore, innerModalOpened } = this.state;

    return (
      <Fragment>
        <Button
          color="link"
          className={classNames(
            'p-0 border-0 text-primary-darker text-underline find-style-modal-link text-transform-none',
            className
          )}
          onClick={this.toggleDrawer}
        >
          <span className="fw-normal">{drawerToggleLinkText}</span>
        </Button>
        <DrawerV2
          isOpen={isOpen}
          toggle={this.toggleDrawer}
          side="right"
          size="xsmall"
          data-tracking-parent={creativeId}
          // Prevent toggle upon nested modal click
          backdrop={innerModalOpened ? 'static' : true}
          trapFocus={!innerModalOpened}
          classNames={{
            drawer: drawerClassNames,
            drawerContainer: drawerContainerClassNames,
          }}
        >
          {(isOpen || wasDrawerOpenedBefore) && (
            <div className="p-1_5 p-md-2">
              <ErrorBoundary>
                <FindStyleDrawerContentAsync
                  lazyLoadingPlaceholderBackButtonSlot={<FindStyleDrawerBackButton toggleDrawer={this.toggleDrawer} />}
                  {...this.props}
                  toggleDrawer={this.toggleDrawer}
                  onInnerModalOpen={this.handleInnerModalOpen}
                  onInnerModalClose={this.handleInnerModalClose}
                />
              </ErrorBoundary>
            </div>
          )}
        </DrawerV2>
      </Fragment>
    );
  }
}
